/** @format */

import {useState} from 'react';

import {Trans} from 'react-i18next';

import {useNavigate} from 'react-router-dom';

import {RecommendationElement} from 'components/RecommendationElement';
import {recommendationName} from 'helpers/recommendation_names';

import {ROUTES} from 'constants/ROUTES';

import RSAModalNew from 'components/RSAModalNew';

import {
  useCreateRecommendationSuspendedMutation,
  useGetRecommendationsQuery,
  useGetSuspendedRecommendationsQuery,
} from './graphql/__generated__';
import {GET_SUSPENDED_RECOMMENDATIONS} from './graphql/recommendation.queries';
import {RecommendationContainer, RecommendationGrid, ReportButton, Title} from './styles';

export const Recommendation = () => {
  const navigate = useNavigate();

  const [selectedRecommendation, setSelectedRecommendation] = useState<string | null>(null);

  const {data} = useGetRecommendationsQuery();
  const {data: suspendedRecommendations} = useGetSuspendedRecommendationsQuery();
  const [suspendRecommendation] = useCreateRecommendationSuspendedMutation({
    refetchQueries: [GET_SUSPENDED_RECOMMENDATIONS],
  });

  const handleClickReport = () => {
    navigate(`/home/main/${ROUTES.PROJECT_REPORTS}`);
  };

  const suspendedRecommendationsResult =
    suspendedRecommendations?.currentUser?.currentCompany?.recommendationSuspendeds;
  const recommendationsResult = data?.currentUser?.currentCompany?.lastRecommendations?.filter(
    ({sensor: {name}, found}) => {
      return (
        !suspendedRecommendationsResult?.some(
          ({sensorName}: {sensorName: string}) => sensorName === name,
        ) && found > 0
      );
    },
  );

  const handleMarkAsRead = async (id: string) => {
    await suspendRecommendation({variables: {input: {sensorName: id}}});
  };

  const handleRecommendationClick = (name: string) => {
    setSelectedRecommendation(name);
  };

  const handleModalClose = () => {
    setSelectedRecommendation(null);
  };

  const recommendationsCount = String(recommendationsResult?.length || 0);
  const showRecommendations = Boolean(recommendationsResult?.length);

  return (
    <RecommendationContainer>
      <>
        <Title>
          <Trans>Рекомендации</Trans>
          <ReportButton variant='contained' onClick={handleClickReport}>
            <Trans>Все рекомендации</Trans>&nbsp;({recommendationsCount})
          </ReportButton>
        </Title>
        <RecommendationGrid>
          {showRecommendations ? (
            recommendationsResult!.map(({sensor: {name}, found}) => (
              <RecommendationElement
                key={recommendationName(name)}
                number={found}
                text={recommendationName(name)}
                onMarkAsRead={() => handleMarkAsRead(name)}
                onClick={() => handleRecommendationClick(name)}
              />
            ))
          ) : (
            <RecommendationElement
              number={0}
              text='Новых рекомендаций нет'
              onMarkAsRead={() => {}}
            />
          )}
        </RecommendationGrid>
      </>
      {selectedRecommendation && (
        <RSAModalNew
          onClose={handleModalClose}
          type={selectedRecommendation}
          title={recommendationName(selectedRecommendation)}
        />
      )}
    </RecommendationContainer>
  );
};
